import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LanguageService } from "../services/language.service";

@Injectable({ providedIn: 'root' })
export class LanguageFileResolver implements Resolve<any> {
  constructor(private languageService: LanguageService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    if (route.queryParams && route.queryParams.locale) {
      this.languageService.lang = route.queryParams.locale;
    } else {
      this.languageService.lang = navigator.language;
    }
    return this.languageService.getLangFile(route.data.languageComponent)
      .pipe(
        map(res => res ? res : {}),
        catchError(() => of(null))
      );
  }
}
